export default [{
	path: '/aiPackage/list',
	name: 'AiPackageList',
	component: () => import('../views/aiPackage/list'),
	meta: {
		title: 'AI套餐-套餐管理',
		keepAlive: false
	}
}]
